module.exports = __webpack_public_path__ + "img/training_system2.f1d367b5.jpg";